(function () {
  var popup = document.getElementById('trailnest-popup');
  if (!popup) return;

  var STORAGE_KEY = 'tn_popup_last_shown';
  var frequency = popup.dataset.frequency || 'session';
  var delay = parseInt(popup.dataset.delay, 10) || 8000;
  var scrollPercent = parseInt(popup.dataset.scrollPercent, 10) || 50;

  function frequencyMs() {
    if (frequency === 'day') return 24 * 60 * 60 * 1000;
    if (frequency === 'week') return 7 * 24 * 60 * 60 * 1000;
    return null; // session: handled via sessionStorage instead
  }

  function alreadyShown() {
    if (frequency === 'session') {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    }
    var last = localStorage.getItem(STORAGE_KEY);
    if (!last) return false;
    return Date.now() - parseInt(last, 10) < frequencyMs();
  }

  function markShown() {
    if (frequency === 'session') {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } else {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    }
  }

  function showPopup() {
    if (alreadyShown()) return;
    popup.hidden = false;
    markShown();
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.hidden = true;
    document.body.style.overflow = '';
  }

  popup.querySelectorAll('[data-tn-close]').forEach(function (el) {
    el.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hidden) closePopup();
  });

  if (alreadyShown()) return;

  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  if (isMobile) {
    var triggered = false;
    window.addEventListener('scroll', function () {
      if (triggered) return;
      var scrollTop = window.scrollY;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var percent = (scrollTop / docHeight) * 100;
      if (percent >= scrollPercent) {
        triggered = true;
        showPopup();
      }
    }, { passive: true });
  } else {
    setTimeout(showPopup, delay);
  }
})();